module.exports = __webpack_public_path__ + "static/media/1002795.623276f3.png";